export { default as OAuthAuthorize } from "./oauth-authorize.component";